import styled from 'styled-components';
import media from 'styled-media-query';

import { AccountSubscriptionLpButton } from '../../../atoms/lp/accountSubscription/AccountSubscriptionLpButton';
import { LpSpSlider } from '../LpSpSlider';

import { LIGHT_TAX_INCLUDED_PRICE } from '../../../../const';

import ImageBgPc from '../../../../static/image/lp/fv_bg_pc.png';

import LpMovie from '../../../../static/movie/lp_fv_pc.mp4';
import FvAfter from '../../../../static/image/lp/ad/fv_after_pc.png';

interface AccountSubscriptionLpFvContentProps {
  onClickCV: () => void;
}

export const AccountSubscriptionLpFvContent: React.FC<AccountSubscriptionLpFvContentProps> = ({ onClickCV }) => {
  return (
    <Section>
      <Wrapper>
        <LpSpSlider />

        <TopWrapper>
          <Inner>
            <Title>
              <SubTitle>日本最安級！サブスク型オンラインITスクール</SubTitle>
              <span>教材・課題・Q&A・レッスン</span>
              <TitleDetail>などの機能で学習のつまずきをゼロに！</TitleDetail>
              <TitleDetail>仕事につながるスキルを習得</TitleDetail>
            </Title>
            <Sup>累計45,000名以上の指導実績！</Sup>
            <Reason>
              <ReasonColumn>
                <h2>月額料金</h2>
                <p>
                  {LIGHT_TAX_INCLUDED_PRICE.toLocaleString()}
                  <span>円~</span>
                  <small>(税込み)</small>
                </p>
              </ReasonColumn>
              <ReasonColumn>
                <h2>
                  講師への満足度<span>※1</span>
                </h2>
                <p>
                  95<span>%</span>
                </p>
              </ReasonColumn>
              <ReasonColumn>
                <h2>
                  挫折率<span>※2</span>
                </h2>
                <p>
                  8<span>%</span>
                </p>
              </ReasonColumn>
            </Reason>
            <ButtonArea>
              <AccountSubscriptionLpButton onClick={onClickCV} subscription />
              <Description>
                <span>(※1) 弊社提供のレッスン、セミナーオンラインコースなどのサービスを含む</span>
                <span>(※2) 弊社提供のマンツーマンレッスンの実績に基づくデータ</span>
              </Description>
            </ButtonArea>
          </Inner>
          <Video src={LpMovie} loop autoPlay muted />
        </TopWrapper>
      </Wrapper>
      <Image src={FvAfter} alt="FvAfter" />
    </Section>
  );
};

const Image = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
`;

const Section = styled.section`
  height: 640px;
  background-color: #fff;
  padding: 3rem 0 0;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
  background: url(${ImageBgPc}) center top / contain no-repeat;
  background-size: contain;
  background-color: #fff0f0;

  ${media.lessThan('medium')`
    height: auto;
    padding-top: 2rem;
    padding-bottom: 1.5rem;
    background-image: none;
  `}
`;
const Wrapper = styled.div`
  max-width: 85.25rem;
  padding: 0;
  margin: 0 auto;
  box-sizing: border-box;

  .sp {
    display: none;

    ${media.greaterThan('medium')`
      display: block;
    `}
  }
`;
const Video = styled.video`
  min-width: 0px;
  position: absolute;
  right: -4rem;
  top: -3rem;
  ${media.lessThan('medium')`
    display: none;
  `}
`;
const TopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 425px;
  position: relative;
  margin: 0 2rem;
`;
const Inner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  left: 0;
  z-index: 1;

  ${media.lessThan('medium')`
    align-items: center;
    margin-top: 1rem;
    width: 100%;
  `}
`;

const SubTitle = styled.p`
  color: #111;
  font-size: 1.125rem;
  font-weight: 800;
  line-height: 1.75rem;

  ${media.lessThan('medium')`
    font-size: .75rem;
    line-height: 1.125rem;
  `}
`;
const TitleDetail = styled.p`
  margin-top: 0.375rem;
  font-size: 2.25rem;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: 0.02em;

  ${media.lessThan('medium')`
    margin-top: .125rem;
    font-size: 1.375rem;
    line-height: 2rem;
    white-space: normal;
    word-break: break-word;

  `}

  ${media.lessThan('small')`
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    font-size: 1.25rem;
    line-height: 1.75rem;
  `}
`;
const Title = styled.h1`
  margin-top: 0.375rem;
  font-size: 2.25rem;
  font-weight: 800;
  line-height: 1.5;
  letter-spacing: 0.02em;

  span {
    display: inline-block;
    padding: 0 0.375rem;
    background: #eb0000;
    color: #fff;
    font-size: 1em;
    font-weight: 800;
  }

  ${media.lessThan('medium')`
    margin-top: .125rem;
    font-size: 1.375rem;
    line-height: 2rem;
    white-space: normal;
    word-break: break-word;

    span {
      padding: 0 .25rem;
    }
  `}

  ${media.lessThan('small')`
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    font-size: 1.25rem;
    line-height: 1.75rem;

    br {
      display: none;
    }
  `}
`;
const Sup = styled.p`
  margin-top: 1.125rem;
  color: #111;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1rem;
  letter-spacing: 0.05em;
  text-align: center;

  span {
    font-size: 0.625rem;
    font-weight: 400;
    line-height: 1;
  }

  ${media.lessThan('medium')`
    margin-top: 1.25rem;
    font-size: .75rem;
    line-height: .875rem;
  `}
`;
const Reason = styled.div`
  display: flex;
  gap: 1rem;
  margin: 0.875rem auto 0;

  ${media.lessThan('medium')`
    margin-top: .625rem;
  `}
`;
const ReasonColumn = styled.div`
  flex: 1;
  min-width: 160px;
  padding: 0.875rem 0 0.5rem;
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 0.25rem 1rem rgba(111, 35, 35, 0.125);
  text-align: center;

  h2 {
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 1.125rem;

    span {
      color: rgba(0, 0, 0, 0.36);
      font-size: 0.625rem;
      font-weight: 400;
      line-height: 1;
    }
  }

  p {
    margin-top: 0.375rem;
    color: #eb0000;
    font-size: 1.875rem;
    font-weight: 800;
    line-height: 1em;
    letter-spacing: -0.03em;
    white-space: nowrap;

    span {
      font-size: 0.875rem;
      font-weight: 700;
      line-height: 1.25rem;
    }

    small {
      display: block;
      margin-top: 0.125rem;
      color: rgba(0, 0, 0, 0.36);
      font-size: 0.625rem;
      font-weight: 700;
      line-height: 1;
    }
  }

  ${media.lessThan('medium')`
    min-width: 24vw;

    h2 {
      font-size: .75rem;
      line-height: 1rem;
    }

    p {
      font-size: 1.25rem;

      span {
        font-size: .625rem;
        line-height: .875rem;
      }
    }
  `}
`;
const ButtonArea = styled.div`
  max-width: 392px;
  margin: 1.125rem auto 0;

  ${media.lessThan('medium')`
    margin-top: 1.25rem;
  `}
`;
const Description = styled.p`
  margin-top: 0.5rem;

  span {
    display: block;
    color: #111;
    font-size: 0.625rem;
    line-height: 0.875rem;
  }

  ${media.lessThan('medium')`
    margin-top: 1.125rem;
  `}
`;
